import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-ticket-filter',
  templateUrl: './ticket-filter.component.html',
  styleUrls: ['./ticket-filter.component.css']
})
export class TicketFilterComponent implements OnInit {

  usersList: any= []
  status = "OPEN"
  userId = ""
  startDate = ""
  endDate = ""
  filteredData: any= []

  pageNumber: number = 0;
  totalRecords: number = 0;
  recordsPerPage:number = 10;
  tableSize: number = 10;

  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }

  ngOnInit(): void {
    this.getUsers()
  }
  getUsers(){
    this.generic_service.getUsers().subscribe(
      (res:any)=>{
        this.usersList = res.response;
      }
    )
  }

  onTableDataChange(event: any) {
    this.pageNumber = event;
    this.filterByTicketStatusAndBetweenDates(this.status,this.pageNumber-1,this.recordsPerPage)
  }

  searchFilter(){
    this.pageNumber = 0
    this.filterByTicketStatusAndBetweenDates(this.status,this.pageNumber,this.recordsPerPage)
  }

  filterByTicketStatusAndBetweenDates(status: any,pageNumber:any,recordsPerPage:any){
    let startDate = new Date(this.startDate).getTime()
    let endDate = new Date(this.endDate).getTime()
    this.generic_service.filterByTicketStatusAndBetweenDates(status,pageNumber,recordsPerPage,startDate,endDate).subscribe(
      (response:any)=>{
        console.log(response)
        this.filteredData = []
        this.totalRecords = response.response.totalRecords

        this.filteredData = response.response.ticketList
      },
      (error:any)=>{
        console.log(error)
      }
    )
  }
}